<span  style="--color:var({{color.replaceAll('_', '-')}})"></span> {{ text | translate }}